export default __webpack_public_path__ + "static/media/coins.3891d043.webp";